var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDropDownIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9978 14.4999L11.997 14.4999C11.9312 14.5003 11.866 14.4877 11.8051 14.4628C11.7444 14.4381 11.6892 14.4016 11.6426 14.3555C11.6424 14.3553 11.6422 14.3551 11.6421 14.3549L7.64349 10.3564C7.54896 10.2619 7.49585 10.1336 7.49585 9.99994C7.49585 9.86625 7.54896 9.73803 7.64349 9.64349C7.73803 9.54896 7.86625 9.49585 7.99994 9.49585C8.13353 9.49585 8.26166 9.54888 8.35617 9.64328C8.35624 9.64335 8.35632 9.64342 8.35639 9.64349L11.6459 12.943L11.9994 13.2976L12.3535 12.9435L15.6275 9.6695C15.7213 9.59425 15.8392 9.5552 15.9597 9.55986C16.0855 9.56472 16.2049 9.61688 16.294 9.70593C16.383 9.79498 16.4352 9.91435 16.44 10.0402C16.4447 10.1607 16.4056 10.2786 16.3304 10.3724L12.3478 14.3549C12.3476 14.3551 12.3474 14.3553 12.3472 14.3555C12.2542 14.4475 12.1287 14.4994 11.9978 14.4999Z",
    fill: "#A098AE",
    stroke: "#A098AE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropDownIcon);
export default __webpack_public_path__ + "static/media/dropDownIcon.76bd185c54e4db0db576df1c0765db7d.svg";
export { ForwardRef as ReactComponent };